import { Navigate, Outlet } from 'react-router';
import { PROTECTED_PATHS } from '../navigation/paths';
import useAuth from '@/features/auth/hooks/useAuth';

export default function GuestGuard() {
  const { parent, isLoading } = useAuth();

  if (isLoading) {
    return null;
  }

  if (parent) {
    return <Navigate to={PROTECTED_PATHS.children} replace />;
  } else {
    return <Outlet />;
  }
}
